module.exports = __webpack_public_path__ + "static/media/contract-voided.79eb3454.svg";